<template>
    <div>
        <div>
            <eventManage></eventManage>
            <problemManage></problemManage>
            <firstLineEvent></firstLineEvent>
            <secondLineEvent></secondLineEvent>
            <serviceList></serviceList>
            <otherList></otherList>
        </div>

    </div>
</template>

<script>
    import eventManage from './eventManage/eventManage'
    import otherList from './report/index'
    import firstLineEvent from './firstLineEvent/firstLineEvent'
    import secondLineEvent from './secondLineEvent/secondLineEvent'
    import problemManage from './problemManage/problemManage'
    import serviceList from './serviceList/serviceList'
    export default {
        name: "reportsList",
        components:{
            eventManage,
            otherList,
            firstLineEvent,
            secondLineEvent,
            problemManage,
            serviceList
        },
    }
</script>

<style scoped>
@import "../../assets/iconImg/wikihelp.css";
</style>
